module.exports = __webpack_public_path__ + "img/screenShow1.4857072.png";